/* eslint-disable import/no-anonymous-default-export, react/display-name -- decisionId=IRV3-DECISION-GAIAI-ROUTE-COMPANIONS expiresAt=2026-06-30 file=frontend/app/(public)/error.tsx line=1 reason=next_route_companion_default */

"use client";

import { ButtonV2 } from "@/components/ui-v2";

export default function ({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <main className="flex min-h-screen items-center justify-center bg-white px-4">
      <section className="max-w-lg space-y-4 text-center">
        <h1 className="text-2xl font-semibold text-slate-950">
          Sayfa yüklenemedi
        </h1>
        <p className="text-sm leading-6 text-slate-600">
          Lütfen bağlantınızı kontrol edip tekrar deneyin.
        </p>
        <ButtonV2 type="button" onClick={reset} size="md" variant="primary">
          Tekrar dene
        </ButtonV2>
      </section>
    </main>
  );
}
